// Shared by the create and edit business forms, for both the input limit and its counter.
export const PURCHASE_ORDER_REFERENCE_MAX_LENGTH = 200;
